(() => {
  const enhance = () => {
    document.querySelectorAll('.bf-payment-methods .shopify-payment-button__more-options').forEach(button => {
      const label = 'Elegir cómo pagar →';
      if (button.textContent !== label) button.textContent = label;
      button.setAttribute('aria-label', 'Continuar al pago y elegir método de pago');
    });
    document.querySelectorAll('.bf-ritual__collection').forEach(root => {
      if (root.dataset.carouselReady) return;
      const track = root.querySelector('.bf-ritual__products');
      const controls = root.querySelector('.bf-explore-controls');
      if (!track || !controls) return;
      root.dataset.carouselReady = 'true';
      const buttons = [...controls.querySelectorAll('button')];
      let frame = 0;
      const update = () => {
        if (frame) return;
        frame = requestAnimationFrame(() => {
          frame = 0;
          const max = track.scrollWidth - track.clientWidth;
          const left = track.scrollLeft;
          const hidden = max < 4;
          if (controls.hidden !== hidden) controls.hidden = hidden;
          buttons[0].disabled = left < 4;
          buttons[1].disabled = left >= max - 4;
        });
      };
      buttons.forEach(button => button.addEventListener('click', () => {
        const first = track.querySelector('.bf-ritual__product');
        const step = first.getBoundingClientRect().width + parseFloat(getComputedStyle(track).columnGap);
        track.scrollBy({left:step * Number(button.dataset.step),behavior:matchMedia('(prefers-reduced-motion:reduce)').matches?'auto':'smooth'});
      }));
      track.addEventListener('scroll', update, {passive:true});
      const observer = new ResizeObserver(() => { if(!root.isConnected) observer.disconnect(); else update(); });
      observer.observe(track);
      update();
    });
  };
  let pending=false;
  const observer=new MutationObserver(() => {
    if(pending) return;
    pending=true;
    requestAnimationFrame(()=>{pending=false;enhance();});
  });
  const init=()=>{
    enhance();
    // Payment widgets update asynchronously. Observe their containers, not every
    // review, cart, chat and animation mutation across the entire storefront.
    document.querySelectorAll('.bf-payment-methods').forEach(root=>{
      observer.observe(root,{childList:true,subtree:true});
    });
    document.addEventListener('shopify:section:load',event=>{
      enhance();
      event.target.querySelectorAll('.bf-payment-methods').forEach(root=>observer.observe(root,{childList:true,subtree:true}));
    });
  };
  if(document.readyState==='loading') document.addEventListener('DOMContentLoaded',init,{once:true}); else init();
})();

/* Klaviyo welcome teaser: visible at the top of the page, hidden while scrolling so it never covers the sticky add-to-cart bar. */
(() => {
  const isTeaser = el => {
    const text = (el.textContent || '').trim();
    return text.length > 0 && text.length < 80 && /bienvenida|10\s*%/i.test(text) && getComputedStyle(el).position === 'fixed';
  };
  let hidden = null, frame = 0;
  const update = () => {
    frame = 0;
    const hide = window.innerWidth < 750 || window.scrollY > 120;
    if (hide === hidden) return;
    hidden = hide;
    document.querySelectorAll('[class*="kl-teaser"], div.needsclick').forEach(el => {
      if (!isTeaser(el)) return;
      el.style.transition = 'opacity .25s ease, transform .25s ease';
      el.style.opacity = hide ? '0' : '';
      el.style.transform = hide ? 'translateY(20px)' : '';
      el.style.pointerEvents = hide ? 'none' : '';
    });
  };
  window.addEventListener('scroll', () => { if (!frame) frame = setTimeout(update, 60); }, { passive: true });
  window.addEventListener('resize', () => { hidden = null; if (!frame) frame = setTimeout(update, 60); });
  setTimeout(update, 0);
  new MutationObserver(() => { hidden = null; if (!frame) frame = setTimeout(update, 60); }).observe(document.body, { childList: true });
})();
